// extracted by mini-css-extract-plugin
export default {"mCard":"LC-z","image":"MC-z","imageNoBackground":"NC-z","imageHasCategory":"OC-z","fullWidth":"PC-z"};